/**
 * Membership kind — the one choice of three the user form now shows instead
 * of two independent (and contradictable) checkboxes. `users/post` is
 * unchanged: it still takes `isUserGuest`/`isPrivate` booleans, so the form
 * keeps deriving them from the selected kind rather than sending it as its
 * own field.
 */
export const MEMBERSHIP_KIND_EMPLOYEE = "employee";
export const MEMBERSHIP_KIND_AUTHORIZED = "authorized";
export const MEMBERSHIP_KIND_GUEST = "guest";

/** Selected kind → the isUserGuest/isPrivate flags `users/post` expects. */
export function membershipKindToFlags(kind) {
  if (kind === MEMBERSHIP_KIND_AUTHORIZED) return { isUserGuest: false, isPrivate: true };
  if (kind === MEMBERSHIP_KIND_GUEST) return { isUserGuest: true, isPrivate: false };
  return { isUserGuest: false, isPrivate: false };
}

/**
 * The stored isUserGuest/isPrivate flags → the kind the selector shows.
 * isUserGuest wins when both happen to be true (the new UI cannot produce
 * that, but old data might) — per owner decision 25.09.2026, such legacy
 * rows always behaved as guests and are migrated to Guest here.
 */
export function flagsToMembershipKind({ isUserGuest, isPrivate } = {}) {
  if (isUserGuest) return MEMBERSHIP_KIND_GUEST;
  if (isPrivate) return MEMBERSHIP_KIND_AUTHORIZED;
  return MEMBERSHIP_KIND_EMPLOYEE;
}
